import { Rect } from '../primitives/rect';
import { getFunction } from '../utility/base-util';
import { HierarchicalTree } from './hierarchical-tree';
/**
 * Layout for mind-map tree
 */
export class MindMap {
    /**
     * Constructor for the organizational chart module.
     *
     * @private
     */
    constructor() {
        /**
         * Defines the layout animation
         *
         */
        this.isAnimation = false;
        //constructs the layout module
    }
    /**
     * To destroy the organizational chart
     *
     * @returns {void}
     * @private
     */
    destroy() {
        /**
         * Destroy method performed here
         */
    }
    /**
     * Get module name.
     */
    getModuleName() {
        /**
         * Returns the module name of the layout
         */
        return 'MindMapChart';
    }
    /**
     * @param nodes
     * @param nameTable
     * @param layoutProp
     * @param viewPort
     * @param uniqueId
     * @param root
     * @private
     */
    updateLayout(nodes, nameTable, layoutProp, viewPort, uniqueId, root) {
        const isRoot = this.checkRoot(nodes, layoutProp, uniqueId, root, nameTable);
        if (isRoot) {
            layoutProp.fixedNode = isRoot;
        }
        else {
            for (const node of nodes) {
                if (!node.excludeFromLayout) {
                    if (!node.inEdges || !node.inEdges.length) {
                        layoutProp.fixedNode = node.id;
                        break;
                    }
                }
            }
        }
        const rootNode = nameTable[layoutProp.fixedNode];
        const fistLevelNodes = this.findFirstLevelNodes(rootNode, layoutProp, nameTable);
        const leftNodes = [];
        const rightNodes = [];
        let getMindmapBranch = getFunction(layoutProp.getBranch);
        getMindmapBranch = getMindmapBranch || getFunction(this.getBranch);
        for (const node of fistLevelNodes) {
            let align = getMindmapBranch(node, fistLevelNodes);
            align = node && node.branch ? node.branch : align;
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            (align === 'Left') ? leftNodes.push(node) : rightNodes.push(node);
        }
        const viewPortBounds = new Rect(0, 0, viewPort.x, viewPort.y);
        nameTable[layoutProp.fixedNode].offsetX = viewPortBounds.x + viewPortBounds.width / 2;
        nameTable[layoutProp.fixedNode].offsetY = viewPortBounds.y + viewPortBounds.height / 2;
        if (leftNodes.length) {
            this.updateMindMapBranch(nodes, rightNodes, nameTable, layoutProp, viewPort, uniqueId, 'Left');
        }
        if (rightNodes.length) {
            this.updateMindMapBranch(nodes, leftNodes, nameTable, layoutProp, viewPort, uniqueId, 'Right');
        }
    }
    checkRoot(nodes, layoutProp, uniqueId, root, nameTable) {
        for (const node of nodes) {
            if (!node.excludeFromLayout) {
                if (node.data && (node.data[`${uniqueId}`].toString() === root || node.data[`${uniqueId}`].toString()
                    === layoutProp.root)) {
                    return node.id;
                }
                else if (!node.data && node.id === layoutProp.root) {
                    return node.id;
                }
            }
        }
        return '';
    }
    updateMindMapBranch(nodes, excludeNodes, nameTable, layoutProp, viewPort, uniqueId, side) {
        const layout = {
            type: 'HierarchicalTree',
            horizontalSpacing: layoutProp.verticalSpacing, verticalSpacing: layoutProp.horizontalSpacing,
            verticalAlignment: layoutProp.verticalAlignment, horizontalAlignment: layoutProp.horizontalAlignment,
            fixedNode: layoutProp.fixedNode, getLayoutInfo: getFunction(layoutProp.getLayoutInfo),
            layoutInfo: layoutProp.layoutInfo, margin: layoutProp.margin,
            orientation: layoutProp.orientation,
            root: layoutProp.fixedNode
        };
        //(EJ2-277624)-Vertical orientation is not working in mindmap
        if (layout.orientation === 'Vertical') {
            layout.orientation = (side === 'Left') ? 'TopToBottom' : 'BottomToTop';
        }
        else {
            layout.orientation = (side === 'Left') ? 'LeftToRight' : 'RightToLeft';
        }
        this.excludeFromLayout(excludeNodes, nameTable, true);
        const mapLayout = new HierarchicalTree();
        mapLayout.updateLayout(nodes, nameTable, layout, viewPort, uniqueId);
        this.excludeFromLayout(excludeNodes, nameTable, false);
    }
    getBranch(obj, firstLevelNodes) {
        let side;
        const i = firstLevelNodes.indexOf(obj);
        if (i % 2 === 0) {
            side = 'Left';
        }
        else {
            side = 'Right';
        }
        return side;
    }
    excludeFromLayout(newCollection, nameTable, exclude) {
        for (const newcol of newCollection) {
            const node = nameTable[newcol.id];
            node.excludeFromLayout = exclude;
        }
    }
    findFirstLevelNodes(node, layout, nameTable) {
        let parentNode;
        const fistLevelNodes = [];
        if (node && node.outEdges.length) {
            for (const outEdge of node.outEdges) {
                fistLevelNodes.push(nameTable[nameTable[`${outEdge}`].targetID]);
            }
        }
        return fistLevelNodes;
    }
}
